<template>
  <div
    class="filters mr-4 w-100 justify-content-between d-flex align-items-center flex-column flex-lg-row"
  >
    <BDXManagementTableFiltersBDXStatus v-model="modelValue.bdx_status" />
    <BDXManagementTableFiltersFCPStatus v-model="modelValue.fcp_status" />
    <BDXManagementTableFiltersRECStatus
      v-if="isSuperUser"
      v-model="modelValue.rec_status"
    />
    <BDXManagementTableFiltersClaimStatus v-model="modelValue.claim_status" />
    <BDXManagementTableFiltersPaymentStatus
      v-model="modelValue.payment_status"
    />
    <BDXManagementTableFiltersPendingReserves v-model="modelValue.reserve" />
    <BDXManagementTableFiltersCreateDate v-model="modelValue.created_on" />
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { useCurrentUser } from '@composables'

import BDXManagementTableFiltersBDXStatus from './BDXManagementTableFiltersBDXStatus.vue'
import BDXManagementTableFiltersFCPStatus from './BDXManagementTableFiltersFCPStatus.vue'
import BDXManagementTableFiltersRECStatus from './BDXManagementTableFiltersRECStatus.vue'
import BDXManagementTableFiltersPaymentStatus from './BDXManagementTableFiltersPaymentStatus.vue'
import BDXManagementTableFiltersPendingReserves from './BDXManagementTableFiltersPendingReserves.vue'
import BDXManagementTableFiltersClaimStatus from './BDXManagementTableFiltersClaimStatus.vue'
import BDXManagementTableFiltersCreateDate from './BDXManagementTableFiltersCreateDate.vue'

export default defineComponent({
  name: 'BDXManagementTableFilters',
  components: {
    BDXManagementTableFiltersBDXStatus,
    BDXManagementTableFiltersFCPStatus,
    BDXManagementTableFiltersRECStatus,
    BDXManagementTableFiltersPaymentStatus,
    BDXManagementTableFiltersPendingReserves,
    BDXManagementTableFiltersClaimStatus,
    BDXManagementTableFiltersCreateDate
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        bdx_status: 'All',
        fcp_status: 'All',
        rec_status: 'All',
        payment_status: 'All',
        reserve: 'All',
        claim_status: 'All',
        created_on: []
      }),
      validator: (value) =>
        Object.keys(value).every((v) =>
          [
            'company',
            'bdx_status',
            'fcp_status',
            'rec_status',
            'payment_status',
            'reserve',
            'claim_status',
            'created_on'
          ].includes(v)
        )
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { isSuperUser } = useCurrentUser()

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      isSuperUser,

      modelValue
    }
  }
})
</script>

<style scoped>
.filters >>> .base-select {
  max-width: 140px;
}

.filters >>> .base-select >>> label {
  font-size: 12px;
  line-height: 1;
}

.filters >>> .base-select >>> .custom-select {
  width: 140px;
}

@media screen and (max-width: 991px) {
  .filters >>> .base-select {
    width: 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }

  .filters >>> .base-select >>> .custom-select {
    width: 100%;
  }
}
</style>
